<template>
<div>
	<!-- 页签 -->
	<el-tabs v-model="activeName" type="card" class="content-tabs">
		<el-tab-pane label="跟进记录" name="跟进记录"></el-tab-pane>
		<el-tab-pane label="订单信息" name="订单信息"></el-tab-pane>
		<el-tab-pane label="物料明细" name="物料明细"></el-tab-pane>
	</el-tabs>

	<!-- 跟进记录 -->
	<div v-if="activeName=='跟进记录'">
		<div class="info">
			<div class="timeline-item" v-for="(item,index) in recordList" :key="index">
				<div class="item-content">{{ item.feedbackRemark }}</div>
				<div class="item-text">
					<span>{{ item.feedbackTime | formatDay }}</span>
					<span class="name">{{ item.creator }}</span>
					<el-button type="text" size="small" @click="previewImage(item.imageUrl)" v-if="item.imageUrl" class="link" :preview-src-list="srcList">
						<span>预览附件</span>
					</el-button>
				</div>
			</div>
			<!-- 图片预览 -->
			<div class="image-box">
				<el-image src="" ref="recordImgRef" :preview-src-list="recordImgList"></el-image>
			</div>
		</div>
	</div>

	<!-- 订单信息 -->
	<div v-if="activeName=='订单信息'">
		<div class="info">
			<el-descriptions title="SAP返回信息" :column="descriptions.column" size="small" border :labelStyle="{width: '90px'}">
				<el-descriptions-item label="公司代码"> {{ detailInfo.bukrs}} </el-descriptions-item>
				<el-descriptions-item label="客户订单号"> {{ detailInfo.customerpono}} </el-descriptions-item>
				<el-descriptions-item label="销售订单号"> {{ detailInfo.vbeln}} </el-descriptions-item>
				<el-descriptions-item label="交货单号"> {{ detailInfo.delivery }} </el-descriptions-item>
				<el-descriptions-item label="发票凭证号"> {{ detailInfo.kidno }} </el-descriptions-item>
				<el-descriptions-item label="售达方编码"> {{ detailInfo.kunnr }} </el-descriptions-item>
				<el-descriptions-item label="售达方名称"> {{ detailInfo.kunnrT }} </el-descriptions-item>
				<el-descriptions-item label="送达方编码"> {{ detailInfo.kunrg }} </el-descriptions-item>
				<el-descriptions-item label="送达方名称"> {{ detailInfo.name1We }} </el-descriptions-item>
				<el-descriptions-item label="业绩归属"> {{ detailInfo.attribution }} </el-descriptions-item>
				<el-descriptions-item label="业务员"> {{ detailInfo.ywymc }} </el-descriptions-item>
				<el-descriptions-item label="工厂"> {{ detailInfo.werks }} </el-descriptions-item>
				<el-descriptions-item label="SP供应商编码"> {{ detailInfo.lifnr }} </el-descriptions-item>
				<el-descriptions-item label="SP供应商名称"> {{ detailInfo.lifnrT }} </el-descriptions-item>
				<el-descriptions-item label="采购订单号"> {{ detailInfo.ebeln }} </el-descriptions-item>
				<el-descriptions-item label="过账日期"> {{ detailInfo.budat }} </el-descriptions-item>
				<el-descriptions-item label="开票日期"> {{ detailInfo.vatDat }} </el-descriptions-item>
				<el-descriptions-item label="发票号"> {{ detailInfo.xref2 }} </el-descriptions-item>
				<el-descriptions-item label="发票金额"> {{ detailInfo.amount | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="到期日"> {{ detailInfo.netdt }} </el-descriptions-item>
				<el-descriptions-item label="经营模式"> {{ detailInfo.zmodel }} </el-descriptions-item>
				<el-descriptions-item label="合同项目"> {{ detailInfo.zproject1 }} </el-descriptions-item>
				<el-descriptions-item label="客户PO号"> {{ detailInfo.bstkd }} </el-descriptions-item>
				<el-descriptions-item label="金额"> {{ detailInfo.dmbtr | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="信用期限"> {{ detailInfo.xyqxz | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期1月"> {{ detailInfo.yqMonth1 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期2月"> {{ detailInfo.yqMonth2 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期3月"> {{ detailInfo.yqMonth3 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期4月"> {{ detailInfo.yqMonth4 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期5月"> {{ detailInfo.yqMonth5 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期6月"> {{ detailInfo.yqMonth6 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期7月"> {{ detailInfo.yqMonth7 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期8月"> {{ detailInfo.yqMonth8 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期9月"> {{ detailInfo.yqMonth9 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期10月"> {{ detailInfo.yqMonth10 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期11月"> {{ detailInfo.yqMonth11 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期12月"> {{ detailInfo.yqMonth12 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="逾期超1年"> {{ detailInfo.yqMonth13 | formatYuan }} </el-descriptions-item>
				<el-descriptions-item label="源销售订单"> {{ detailInfo.zfromso }} </el-descriptions-item>
				<el-descriptions-item label="订单原因"> {{ detailInfo.augru }} </el-descriptions-item>
				<el-descriptions-item label="原因描述" :span="2"> {{ detailInfo.augruBezei }} </el-descriptions-item>
				<el-descriptions-item label="抬头备注" :span="3"> {{ detailInfo.textVbak }} </el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
	
	<!-- 物料明细 -->
	<div v-if="activeName=='物料明细'">
		<div class="info">
			<el-table :data="materialList" stripe border class="table-list">
				<el-table-column type="expand" v-if="pageData.clientType=='mobile'">
					<template slot-scope="props">
						<el-descriptions title="" column="1" size="small" border :labelStyle="{width: '80px'}" class="table-expand">
							<el-descriptions-item label="数量"> {{ props.row.num }} </el-descriptions-item>
							<el-descriptions-item label="含税单价"> {{ props.row.unitPrice }} </el-descriptions-item>
							<el-descriptions-item label="税率"> {{ props.row.taxRate }} </el-descriptions-item>
							<el-descriptions-item label="含税金额"> {{ props.row.taxMoney }} </el-descriptions-item>
						</el-descriptions>
					</template>
				</el-table-column>
			    <el-table-column width="50" type="index" label="序号" align="center"></el-table-column>
			    <el-table-column label="物料编码" prop="materialCode" min-width="90" align="center"></el-table-column>
				<el-table-column label="物料名称" prop="materialName" min-width="120" align="center" :show-overflow-tooltip="pageData.clientType!='mobile' ? true : false"></el-table-column>
			    <el-table-column label="数量" prop="num" min-width="60" align="center" v-if="pageData.clientType!='mobile'"></el-table-column>
			    <el-table-column label="含税单价" prop="unitPrice" min-width="80" align="center" v-if="pageData.clientType!='mobile'"></el-table-column>
			    <el-table-column label="税率" prop="taxRate" min-width="80" align="center" v-if="pageData.clientType!='mobile'"></el-table-column>
			    <el-table-column label="含税金额" prop="taxMoney" min-width="80" align="center" v-if="pageData.clientType!='mobile'"></el-table-column>
			</el-table>
		</div>
	</div>
	
</div>
</template>
<script>
import util from '../../common/util';
export default {
	name: "RMSDetail",
	props: ["pageData"],
	data() {
		return {
			activeName: '跟进记录',
			descriptions: {
				column: 3,
			},
			recordList: [],
			detailInfo: {},
			recordImgList: [],
			materialList: [],
		};
	},
    filters:{
        formatDay(time){
            return util.formatDate(time)
        },
		formatYuan(val){
			let str = val ? val + '元' : '0.00 元';
		    return str;
		},
    },
	created() {
		if(this.pageData.clientType=="mobile"){ //手机
			this.descriptions.column = 1;
		};
		this.getFeedbackRecord();
		this.getDetailInfo();
		this.queryOrderTempWithItem();
	},
	methods: {
		// 跟进记录
		async getFeedbackRecord() {
			let res = await this.$api.feedbackRecord({ vbeln: this.pageData.vbeln });
			if (res.code === 200) {
				this.recordList = res.result;
			};
		},
		// 订单信息
		async getDetailInfo() {
			let res = await this.$api.receivableDetailInfo({ id: this.pageData.id });
			if (res.code === 200) {
				this.detailInfo = res.result;
			};
		},
		// 物料明细
		async queryOrderTempWithItem() {
			let res = await this.$api.queryOrderTempWithItem({ vbeln: this.pageData.vbeln });
			if (res.code === 200) {
				this.materialList = res.result;
			};
		},
		// 预览图片
		previewImage(url){
			if(!url){return false};
			
			this.recordImgList = url.split(",");
			this.$refs.recordImgRef.showViewer = true;
		},
	}
};
</script>
<style lang="less" scoped>
.info {
	padding-top: 20px;
	.timeline-item {
		padding: 8px 0 8px 40px;
		.item-content {
			line-height: 20px;
			color: #333;
			position: relative;
			&::after {
				content: '';
				display: block;
				width: 8px;
				height: 8px;
				background-color: #000;
				border-radius: 100%;
				position: absolute;
				left: -40px;
				top: 50%;
				margin-top: -4px;
			}
		}
		.item-text {
			margin-top: 20px;
			color: #999;
			.name {
				margin-left:15px;
			}
			.link {
				margin-left: 25px;
			}
		}
	}
	.image-box {
		width: 0;
		height: 0;
		overflow: 0;
		opacity: 0;
	}
	.table-list {
		/deep/.el-table__expanded-cell {
			padding: 0 !important;
			.table-expand {
				.el-descriptions-item__cell {
					height: auto !important;
					padding: 8px 10px !important;
					&.el-descriptions-item__label {
						background-color: #fafafa !important;
						color: #99a9bf !important;
					}
				}
			}
		}
	}
}
</style>
